/**
 * Creates URL-friendly slug from text
 */
export const createSlug = (text: string): string => {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '') // Remove special characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/--+/g, '-') // Replace multiple hyphens
    .trim();
};

/**
 * Creates composite slug with ID for uniqueness
 * @example "Nigeria Lagos" + 74 = "nigeria-lagos-74"
 */
export const createIdentifiableSlug = (name: string, id: number): string => {
  return `${createSlug(name)}-${id}`;
};

/**
 * Extracts ID from composite slug
 * @example "nigeria-lagos-74" → 74
 */
export const extractIdFromSlug = (slug: string): number | null => {
  const match = slug.match(/-(\d+)$/);
  return match ? parseInt(match[1], 10) : null;
};
